import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { TextField } from './fields/TextField';
import { Button } from '../common/Button';
import { emailValidation } from './validation/common.validation';

export interface NewsletterFormInput {
    email: string;
}

interface NewsletterFormProps {
    onSubmit: (input: NewsletterFormInput) => void | Promise<void>;
}

// Newsletter form: e-mail only, with validation. react-hook-form + Tailwind; submits via
// the onSubmit prop (wired to NewsletterService).
export const NewsletterForm = ({ onSubmit }: NewsletterFormProps) => {
    const [busy, setBusy] = useState(false);
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm<NewsletterFormInput>({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: { email: '' },
    });

    const submit = handleSubmit(async (input) => {
        setBusy(true);
        await onSubmit(input);
        setBusy(false);
        reset();
    });

    return (
        <form onSubmit={submit} noValidate className="flex flex-col gap-3">
            <TextField id="newsletter-email" label="e-mail (required):" error={errors.email?.message} registration={register('email', emailValidation)} />
            <div className="flex justify-end">
                <Button type="submit" busy={busy} busyLabel="Subscribing…" className="bg-tone-100">
                    Subscribe
                </Button>
            </div>
        </form>
    );
};
